(function () {
    var MOBILE_BREAKPOINT = 768;

    function init() {
        if (typeof window.ADDON_POPUP === 'undefined' || !window.ADDON_POPUP.enabled || !window.ADDON_POPUP.products || window.ADDON_POPUP.products.length < 1)
            return;

        var formId = window.ADDON_POPUP.formId;
        var overlay = document.getElementById('addon-popup-overlay');
        var productsContainer = document.getElementById('addon-popup-products');
        var dotsContainer = document.getElementById('addon-popup-dots');
        var titleEl = document.getElementById('addon-popup-title');
        var subtitleEl = document.getElementById('addon-popup-subtitle');

        if (!overlay || !productsContainer || !formId)
            return;

        var form = document.getElementById(formId) || document.querySelector('form[id="' + formId + '"]:not([hidden])');
        if (!form && formId.indexOf('product-form-') === 0) {
            var sectionIdPart = formId.replace('product-form-', '');
            var sectionEl = document.getElementById('ProductInfo-' + sectionIdPart) || document.querySelector('[id*="ProductInfo-"]');
            if (sectionEl) form = sectionEl.querySelector('form[data-type="add-to-cart-form"]');
        }
        if (!form || form.tagName !== 'FORM')
            return;
        if (form.id && form.id !== formId) formId = form.id;

        var pendingForm = null;
        var cardBtnText = typeof window.addonPopupAddToBagLabel !== 'undefined' ? window.addonPopupAddToBagLabel : 'Add to bag';
        var bottomAtcText = typeof window.addonPopupAddToCartLabel !== 'undefined' ? window.addonPopupAddToCartLabel : 'Add to cart';
        var addedText = typeof window.addonPopupAddedLabel !== 'undefined' ? window.addonPopupAddedLabel : 'Added';
        var noThanksText = typeof window.addonPopupNoThanksLabel !== 'undefined' ? window.addonPopupNoThanksLabel : 'No Thanks';
        var currentIndex = 0;
        var totalSlides = 0;
        var slidesPerView = 2;
        var selectedVariantIds = [];

        function getOrderedProducts(arr, n) {
            return arr.slice(0, Math.min(n || 8, arr.length));
        }

        /** Same section as the product form: checked upsell-bundle variants (snippets/upsell-bundle.liquid). */
        function getUpsellBundleVariantIds(form) {
            if (!form) return [];
            var section = form.closest('section');
            var root = section || document;
            var bundle = root.querySelector('.upsell-bundle');
            if (!bundle) return [];
            var ids = [];
            bundle.querySelectorAll('.upsell-bundle__checkbox:checked').forEach(function (cb) {
                if (cb.value) ids.push(String(cb.value));
            });
            return ids;
        }

        function clearUpsellBundleCheckboxes(form) {
            if (!form) return;
            var section = form.closest('section');
            var root = section || document;
            var bundle = root.querySelector('.upsell-bundle');
            if (!bundle) return;
            bundle.querySelectorAll('.upsell-bundle__checkbox:checked').forEach(function (cb) {
                cb.checked = false;
            });
        }

        function formDataToBody(form) {
            var cartNotification = document.querySelector('cart-notification');
            var sectionIds = cartNotification && typeof cartNotification.getSectionsToRender === 'function'
                ? cartNotification.getSectionsToRender().map(function (s) { return s.id; })
                : ['cart-notification-products', 'cart-notification-links', 'cart-icon-bubble'];
            var formObj = typeof serializeForm === 'function' ? JSON.parse(serializeForm(form)) : {};
            var bundleVariantIds = getUpsellBundleVariantIds(form);

            if (bundleVariantIds.length > 0) {
                var firstLine = {
                    id: formObj.id,
                    quantity: Number(formObj.quantity || 1)
                };
                if (formObj.properties && typeof formObj.properties === 'object' && Object.keys(formObj.properties).length)
                    firstLine.properties = formObj.properties;
                if (formObj.selling_plan != null && formObj.selling_plan !== '')
                    firstLine.selling_plan = formObj.selling_plan;
                var items = [firstLine];
                bundleVariantIds.forEach(function (vid) {
                    items.push({ id: vid, quantity: 1 });
                });
                return JSON.stringify({
                    items: items,
                    sections: sectionIds,
                    sections_url: window.location.pathname
                });
            }

            formObj.sections = sectionIds;
            formObj.sections_url = window.location.pathname;
            return JSON.stringify(formObj);
        }

        function makeCardHtml(p) {
            var pricePart = '';
            if (p.compare_at_price) {
                pricePart = '<span class="addon-popup-card-compare">' + p.compare_at_price + '</span> <span class="addon-popup-card-current">' + (p.price || '') + '</span>';
            } else {
                pricePart = '<span class="addon-popup-card-current">' + (p.price || '') + '</span>';
            }
            return '<div class="addon-popup-card">' +
                '<div class="addon-popup-card-image">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</div>' +
                '<div class="addon-popup-card-title">' + (p.title || '') + '</div>' +
                '<div class="addon-popup-card-prices">' + pricePart + '</div>' +
                '<button type="button" class="addon-popup-card-btn" data-addon-variant-id="' + p.variant_id + '">' + cardBtnText + '</button></div>';
        }

        function getSlidesPerView() {
            return window.innerWidth <= MOBILE_BREAKPOINT ? 1 : 2;
        }

        function buildSlider(list) {
            productsContainer.innerHTML = '';
            productsContainer.removeAttribute('style');
            list.forEach(function (p) {
                var slide = document.createElement('div');
                slide.className = 'addon-popup-slide';
                slide.innerHTML = makeCardHtml(p);
                productsContainer.appendChild(slide);
            });
            totalSlides = list.length;
            slidesPerView = getSlidesPerView();
            currentIndex = 0;
        }

        function updateLayout() {
            var track = overlay.querySelector('.addon-popup-track');
            if (!track || totalSlides === 0) return;
            var trackWidth = track.offsetWidth;
            if (trackWidth <= 0) {
                setTimeout(updateLayout, 50);
                return;
            }
            slidesPerView = getSlidesPerView();
            var slideWidth = trackWidth / slidesPerView;
            var totalWidth = slideWidth * totalSlides;
            productsContainer.style.width = totalWidth + 'px';
            productsContainer.style.display = 'flex';
            productsContainer.style.flexWrap = 'nowrap';
            productsContainer.style.transition = 'transform 0.3s ease';
            productsContainer.style.transform = 'translate3d(0,0,0)';
            var slides = productsContainer.querySelectorAll('.addon-popup-slide');
            for (var i = 0; i < slides.length; i++) {
                slides[i].style.flex = '0 0 ' + slideWidth + 'px';
                slides[i].style.width = slideWidth + 'px';
                slides[i].style.minWidth = slideWidth + 'px';
                slides[i].style.maxWidth = slideWidth + 'px';
                slides[i].style.boxSizing = 'border-box';
            }
            goTo(currentIndex);
        }

        function goTo(index) {
            if (totalSlides === 0) return;
            var track = overlay.querySelector('.addon-popup-track');
            if (!track || !productsContainer) return;
            var trackWidth = track.offsetWidth;
            if (trackWidth <= 0) return;
            slidesPerView = getSlidesPerView();
            var slideWidth = trackWidth / slidesPerView;
            var maxIndex = Math.max(0, totalSlides - slidesPerView);
            currentIndex = Math.min(maxIndex, Math.max(0, index));
            var offset = -currentIndex * slideWidth;
            productsContainer.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
            var dots = overlay.querySelectorAll('.addon-popup-dot');
            for (var i = 0; i < dots.length; i++)
                dots[i].classList.toggle('addon-popup-dot--active', i === currentIndex);
            var prevBtn = overlay.querySelector('.addon-popup-prev');
            var nextBtn = overlay.querySelector('.addon-popup-next');
            if (prevBtn) prevBtn.style.opacity = currentIndex <= 0 ? '0.4' : '1';
            if (nextBtn) nextBtn.style.opacity = currentIndex >= maxIndex ? '0.4' : '1';
        }

        function renderDots() {
            dotsContainer.innerHTML = '';
            var maxIndex = Math.max(0, totalSlides - slidesPerView);
            for (var i = 0; i <= maxIndex; i++) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'addon-popup-dot' + (i === currentIndex ? ' addon-popup-dot--active' : '');
                dot.setAttribute('aria-label', 'Slide ' + (i + 1));
                dot.dataset.slideIndex = i;
                dotsContainer.appendChild(dot);
            }
        }

        function updateBottomButton() {
            var btn = overlay.querySelector('.addon-popup-no-thanks');
            if (!btn) return;
            if (selectedVariantIds.length > 0) {
                btn.textContent = bottomAtcText;
                btn.classList.add('addon-popup-no-thanks--is-atc');
            } else {
                btn.textContent = noThanksText;
                btn.classList.remove('addon-popup-no-thanks--is-atc');
            }
        }

        function openPopup(form, products) {
            pendingForm = form;
            selectedVariantIds = [];
            var list = getOrderedProducts(products, 8);
            if (list.length === 0) return;
            if (titleEl) titleEl.textContent = window.ADDON_POPUP.title || '';
            if (subtitleEl && window.ADDON_POPUP.subtitle) subtitleEl.textContent = window.ADDON_POPUP.subtitle;
            var noThanksBtn = overlay.querySelector('.addon-popup-no-thanks');
            if (noThanksBtn) {
                noThanksBtn.textContent = noThanksText;
                noThanksBtn.classList.remove('addon-popup-no-thanks--is-atc');
            }
            buildSlider(list);
            renderDots();
            overlay.classList.add('is-open');
            overlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('addon-popup-open');
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    updateLayout();
                });
            });
        }

        function closePopup() {
            overlay.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('addon-popup-open');
            pendingForm = null;
        }

        function addMainProductToCart(done, bodyOverride, formToClearBundle) {
            var body = bodyOverride;
            if (!body && pendingForm) {
                body = formDataToBody(pendingForm);
            }
            if (!body) {
                if (done) done();
                return;
            }
            var url = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js';
            var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
            config.headers = config.headers || {};
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = body;
            fetch(url, config).then(function (r) { return r.json(); }).then(function (data) {
                if (data && data.status) {
                    if (done) done();
                    return;
                }
                var cartNotification = document.querySelector('cart-notification');
                if (cartNotification && typeof cartNotification.renderContents === 'function') {
                    cartNotification.renderContents(data);
                } else {
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                }
                if (formToClearBundle) clearUpsellBundleCheckboxes(formToClearBundle);
                if (done) done();
            }).catch(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (done) done();
            });
        }

        function refreshCartDrawer(done) {
            var cartNotification = document.querySelector('cart-notification');
            if (!cartNotification || typeof cartNotification.getSectionsToRender !== 'function') {
                if (done) done();
                return;
            }
            var sectionIds = cartNotification.getSectionsToRender().map(function (s) { return s.id; }).join(',');
            var url = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
            url = url.replace(/\/$/, '') + '/?sections=' + sectionIds;
            fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); }).then(function (data) {
                if (data && typeof cartNotification.renderContents === 'function')
                    cartNotification.renderContents({ id: null, sections: data });
                if (done) done();
            }).catch(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (done) done();
            });
        }

        function addVariantToCart(variantId, quantity, next) {
            var root = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
            var url = (typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : (root + 'cart/add.js');
            var cartNotification = document.querySelector('cart-notification');
            var sectionIds = cartNotification && typeof cartNotification.getSectionsToRender === 'function'
                ? cartNotification.getSectionsToRender().map(function (s) { return s.id; })
                : ['cart-notification-products', 'cart-notification-links', 'cart-icon-bubble'];
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ id: variantId, quantity: quantity || 1, sections: sectionIds, sections_url: root + 'variants/' + variantId })
            }).then(function (r) { return r.json(); }).then(function (data) {
                if (data && data.status) {
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                } else if (data && data.sections) {
                    var cn = document.querySelector('cart-notification');
                    if (cn && typeof cn.renderContents === 'function')
                        cn.renderContents(data);
                } else {
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                }
                if (next) next();
            }).catch(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                if (next) next();
            });
        }

        function onBottomButtonClick() {
            var formRef = pendingForm;
            var mainProductBody = formRef ? formDataToBody(formRef) : null;
            closePopup();
            var btn = overlay.querySelector('.addon-popup-no-thanks');
            var isAddToCart = btn && btn.classList.contains('addon-popup-no-thanks--is-atc');
            if (!isAddToCart || selectedVariantIds.length === 0) {
                addMainProductToCart(function () {
                    refreshCartDrawer();
                }, mainProductBody, formRef);
                return;
            }
            addMainProductToCart(function () {
                var idx = 0;
                function addNext() {
                    if (idx >= selectedVariantIds.length) {
                        refreshCartDrawer();
                        return;
                    }
                    addVariantToCart(selectedVariantIds[idx], 1, function () {
                        idx++;
                        addNext();
                    });
                }
                addNext();
            }, mainProductBody, formRef);
        }

        function onAddonCardButtonClick(variantId, btn) {
            var id = parseInt(variantId, 10);
            var pos = selectedVariantIds.indexOf(id);
            if (pos === -1) {
                selectedVariantIds.push(id);
                if (btn) {
                    btn.classList.add('addon-popup-card-btn--selected');
                    btn.textContent = addedText;
                }
            } else {
                selectedVariantIds.splice(pos, 1);
                if (btn) {
                    btn.classList.remove('addon-popup-card-btn--selected');
                    btn.textContent = cardBtnText;
                }
            }
            updateBottomButton();
        }

        overlay.addEventListener('click', function (e) {
            if (e.target.closest('[data-addon-close]') || e.target.closest('.addon-popup-close')) {
                e.preventDefault();
                var formRef = pendingForm;
                var mainBody = formRef ? formDataToBody(formRef) : null;
                closePopup();
                addMainProductToCart(function () { refreshCartDrawer(); }, mainBody, formRef);
            }
            if (e.target.closest('[data-addon-no-thanks]') || e.target.closest('.addon-popup-no-thanks')) {
                e.preventDefault();
                if (!e.target.closest('.addon-popup-close')) onBottomButtonClick();
            }
            if (e.target.closest('.addon-popup-card-btn')) {
                var btn = e.target.closest('.addon-popup-card-btn');
                var vid = btn.getAttribute('data-addon-variant-id');
                if (vid) {
                    e.preventDefault();
                    onAddonCardButtonClick(vid, btn);
                }
            }
            if (e.target.closest('.addon-popup-prev')) {
                e.preventDefault();
                goTo(currentIndex - 1);
            }
            if (e.target.closest('.addon-popup-next')) {
                e.preventDefault();
                goTo(currentIndex + 1);
            }
            if (e.target.closest('.addon-popup-dot')) {
                var dot = e.target.closest('.addon-popup-dot');
                var idx = parseInt(dot.dataset.slideIndex, 10);
                if (!isNaN(idx)) goTo(idx);
            }
        });

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if (overlay.classList.contains('is-open') && totalSlides > 0) {
                    updateLayout();
                    renderDots();
                }
            }, 150);
        });

        function isSubscriptionPurchaseSelected() {
            if (typeof window.isSubscriptionPurchaseSelected === 'function') {
                return window.isSubscriptionPurchaseSelected();
            }
            if (typeof window.isFirmhouseSubscriptionSelected === 'function') {
                return window.isFirmhouseSubscriptionSelected();
            }
            return false;
        }

        document.addEventListener('click', function (e) {
            if (window.__subscriptionConfirmSkip || window.__bypassAddonPopup) return;
            var btn = e.target.closest('button[type="submit"]');
            if (!btn) return;
            var targetForm = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
            if (!targetForm || targetForm.id !== formId) return;
            var products = getOrderedProducts(window.ADDON_POPUP.products, 8);
            if (products.length === 0) return;
            if (isSubscriptionPurchaseSelected()) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                if (typeof window.openSubscriptionConfirmPopup === 'function') {
                    window.openSubscriptionConfirmPopup(btn, targetForm);
                }
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            openPopup(targetForm, products);
        }, true);

        document.addEventListener('submit', function (e) {
            if (window.__subscriptionConfirmSkip || window.__bypassAddonPopup) return;
            if (!e.target || e.target.tagName !== 'FORM' || e.target.id !== formId) return;
            if (!window.ADDON_POPUP || !window.ADDON_POPUP.enabled || !window.ADDON_POPUP.products || window.ADDON_POPUP.products.length < 1) return;
            var products = getOrderedProducts(window.ADDON_POPUP.products, 8);
            if (products.length === 0) return;
            if (isSubscriptionPurchaseSelected()) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                if (typeof window.openSubscriptionConfirmPopup === 'function') {
                    var submitButton = e.target.querySelector('button[type="submit"]:not([disabled])');
                    window.openSubscriptionConfirmPopup(submitButton, e.target);
                }
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            openPopup(e.target, products);
        }, true);

        form.addEventListener('submit', function (e) {
            if (window.__subscriptionConfirmSkip || window.__bypassAddonPopup) return;
            if (!window.ADDON_POPUP || !window.ADDON_POPUP.enabled || !window.ADDON_POPUP.products || window.ADDON_POPUP.products.length < 1) return;
            var products = getOrderedProducts(window.ADDON_POPUP.products, 8);
            if (products.length === 0) return;
            if (isSubscriptionPurchaseSelected()) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (typeof window.openSubscriptionConfirmPopup === 'function') {
                    var submitButton = form.querySelector('button[type="submit"]:not([disabled])');
                    window.openSubscriptionConfirmPopup(submitButton, form);
                }
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            openPopup(form, products);
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
